 jQuery(document).ready(function () {

    setTimeout(() => {
       jQuery('.without-caption').magnificPopup({
		type: 'image',
		closeOnContentClick: true,
		closeBtnInside: false,
		mainClass: 'mfp-no-margins mfp-with-zoom', // class to remove default margin from left and right side
		image: {
			verticalFit: true
		},
		zoom: {
			enabled: true,
			duration: 300 // don't foget to change the duration also in CSS
		}
	});

      jQuery('.with-caption').magnificPopup({
      		type: 'image',
      		closeOnContentClick: true,
      		closeBtnInside: false,
      		mainClass: 'mfp-with-zoom mfp-img-mobile',
      		image: {
      			verticalFit: true,
      			titleSrc: function(item) {
      				return item.el.attr('title') + ' &middot; <a class="image-source-link" href="'+item.el.attr('data-source')+'" target="_blank">image source</a>';
      			}
      		},
      		zoom: {
      			enabled: true
      		}
      	});
      }, 1000);
     
   
 })

let elem = document.getElementById('dealer_marketing');
 elem.addEventListener("keydown", function (event) {
    if(event.key == 'Enter'){
      let searched_keyword = document.getElementById('dealer_marketing').value;
      jQuery('#search-btn').click()
    }
});

function queryObject(metaObjectType,method=null,endcurser=null) {
    if(method != null && method == 'default'){
      var count = 30
    }
   else{
      var count = 250
   }
   
    let query = `query MyQuery {
        metaobjects(type: "${metaObjectType}", first: ${count}) {
           pageInfo {
            endCursor
            hasNextPage
          }
          edges {
            node {
              id
              type
              fields {
                key
                value
                reference {
                  ... on MediaImage {
                    id
                    image {
                      src
                    }
                  }
                }
              }
            }
          }
        }
      }`;

    if(endcurser){
        query = `query MyQuery {
        metaobjects(type: "${metaObjectType}", first: ${count},
        after: "${endcurser}"
        ) {
           pageInfo {
            endCursor
            hasNextPage
          }
          edges {
            node {
              id
              type
              fields {
                key
                value
                reference {
                  ... on MediaImage {
                    id
                    image {
                      src
                    }
                  }
                }
              }
            }
          }
        }
      }`;
    }
     
    return settings = {
    "async": true,
    "url": "https://www.nutrishopusa.com/api/2024-01/graphql",
    "method": "POST",
    "headers": {
        "content-type": "application/json",
        "x-shopify-storefront-access-token": "246ababac615bfff9c1d5f2cb7d67f86"
    },
    "data": JSON.stringify({
        query: query,
        variables: {}
    })
    };  
}

$( document ).ready(function() {
    defaultResults(); 
});


htmlElement = ''

jQuery('#clear-search-btn').on('click', function(){
  location.reload();
})

jQuery('#search-btn').on('click', function(){
    jQuery('#grid-listing-no-result').css('display','none')
    jQuery('.owner-portal-loder').css('display','block')
    jQuery('#grid-listing').html('');  
    let searched_keyword = document.getElementById('dealer_marketing').value;
    htmlElement = ''
    params = ["content","dealer_marketing_material","digital_marketing"];
    if(!searched_keyword.startsWith("$", 1)){
         params.forEach(function(value){
          var queryObj = queryObject(value);
          searched_result(queryObj,value)
      })
    }
    else{
      console.log('In Valid String')
    }
   
    
    
})

function searched_result(queryString,result_type){
    $.ajax(queryString).done(function (response) {
        if (response.data) {
         if (response.data.metaobjects.edges) {
            jQuery('#grid-listing-no-result').css('display','none');  
                for (const [key, value] of Object.entries(response.data.metaobjects.edges)) {
                    $elementData =  parseResponse(value);
                    let searched_keyword = document.getElementById('dealer_marketing').value
                    if(searched_keyword.length > 0){
                        metaObject_title = $elementData?.title?.value;
                        if(metaObject_title.toLowerCase().includes(searched_keyword.toLowerCase())){
                            metaObject_id_str = $elementData?.id
                            metaObject_id = metaObject_id_str.replace('gid://shopify/Metaobject/', '');
                            metaObject_type = $elementData?.metaObject_type
                            thumbnail_src = $elementData?.thumbnail?.reference?.image?.src.replace('https://cdn.shopify.com/s/files/1/0685/2647/3535/files/','')
                            image_name = $elementData?.image_name?.value
                            thumbnail_url = $elementData?.thumbnail_url?.value
                            layout = $elementData?.layout?.value
                            side = $elementData?.side?.value
                            style = $elementData?.style?.value
                            title = $elementData?.title?.value
                            display_title = $elementData?.display_title?.value.replace('[','').replace(']','')
                            type = $elementData?.type?.value;
                            if(jQuery(`#grid-listing div[data-id="${metaObject_id}"]`).length == 0 ){
                              
                               htmlElement = `<div  class="views-row col-xs-12 col-sm-6 col-md-4 col-lg-4 entry-content" data-id="${metaObject_id}" data-type="${metaObject_type}" data-title="${display_title ?? title}" data-key ="${display_title ?? title}">
                                   <div class="field-thumbnail">
                                   <div class="field-content">
                                
                                   <a class="zoom-ctrl gallery without-caption" href="https://cdn.shopify.com/s/files/1/0685/2647/3535/files/${thumbnail_src ?? image_name ?? thumbnail_url}" title="${display_title ?? title}">
                                   <img src="https://cdn.shopify.com/s/files/1/0685/2647/3535/files/${thumbnail_src ?? image_name ?? thumbnail_url}" width="371" height="480" alt="${display_title ?? title}">
                                   </a>
                                   </div>
                                   </div>
                                    <div class="title">
                                    <label for="row-entry_index" style="text-transform:capitalize;" type="${type}"> ${display_title ?? title } </label>
                                    </div>
                                   </div>`;
                                jQuery('#grid-listing').append(htmlElement)
                            }
                        }
                    }
                    else{
                          metaObject_id += '<div>No Result Found</div>'
                    }
                }
                if(htmlElement == ''){
                    jQuery('#grid-listing').html(htmlElement)
                }
                else{
                     jQuery('.grid-wrapper').css('display','none');
                }

                
           }
        }
        if(response.data.metaobjects?.pageInfo?.endCursor && response.data.metaobjects?.pageInfo?.hasNextPage == true){
          var queryObjFormore = queryObject(result_type,'searched',response.data.metaobjects?.pageInfo?.endCursor);
          searched_result(queryObjFormore,result_type)
        }
        else{
          if(result_type == 'digital_marketing'){
            if(jQuery('#grid-listing div.views-row').length == 0){
                jQuery('.owner-portal-loder').css('display','none')
               jQuery('#grid-listing-no-result').css('display','block')
             }
             else{
               jQuery('.owner-portal-loder').css('display','none')
               jQuery('#grid-listing-no-result').css('display','none');  
               jQuery('.grid-wrapper').css('display','block');
                       jQuery('.without-caption').magnificPopup({
                		type: 'image',
                		closeOnContentClick: true,
                		closeBtnInside: false,
                		mainClass: 'mfp-no-margins mfp-with-zoom', // class to remove default margin from left and right side
                		image: {
                			verticalFit: true
                		},
                		zoom: {
                			enabled: true,
                			duration: 300 // don't foget to change the duration also in CSS
                		}
                	 });
                
                      jQuery('.with-caption').magnificPopup({
                      		type: 'image',
                      		closeOnContentClick: true,
                      		closeBtnInside: false,
                      		mainClass: 'mfp-with-zoom mfp-img-mobile',
                      		image: {
                      			verticalFit: true,
                      			titleSrc: function(item) {
                      				return item.el.attr('title') + ' &middot; <a class="image-source-link" href="'+item.el.attr('data-source')+'" target="_blank">image source</a>';
                      			}
                      		},
                      		zoom: {
                      			enabled: true
                      		}
                      	});
                     
               }
            }
        }
        
    })
}




 function parseResponse(data,keyword){
    dataObj = {};
    for (const [key, value] of Object.entries(data?.node?.fields)) {
        dataObj[value.key] = value 
        
    }
   dataObj['id'] = data?.node?.id
   dataObj['metaObject_type'] = data?.node?.type
   
   return dataObj    
 }

function defaultResults(){
  var htmlElement = '';
  query = queryObject('digital_marketing','default');
  
   $.ajax(query).done(function (response) {
        if (response.data) {
          if (response.data.metaobjects.edges) {
            for (const [key, value] of Object.entries(response.data.metaobjects.edges)) {
              $elementData =  parseResponse(value);
               
               metaObject_id_str = $elementData?.id
                            metaObject_id = metaObject_id_str.replace('gid://shopify/Metaobject/', '');
              metaObject_type = $elementData?.metaObject_type
              thumbnail_src = $elementData?.thumbnail?.reference?.image?.src.replace('https://cdn.shopify.com/s/files/1/0685/2647/3535/files/','')
              image_name = $elementData?.image_name?.value
              thumbnail_url = $elementData?.thumbnail_url?.value
              layout = $elementData?.layout?.value
              side = $elementData?.side?.value
              style = $elementData?.style?.value
              title = $elementData?.title?.value
              display_title = $elementData?.display_title?.value.replace('[','').replace(']','')
              type = $elementData?.type?.value
              htmlElement += `<div  class="views-row col-xs-12 col-sm-6 col-md-4 col-lg-4 entry-content" data-id="${metaObject_id}" data-type="${metaObject_type}" data-title="${display_title ?? title}" type="type ??  " data-key ="${display_title ?? title}"  >
                     <div class="field-thumbnail">
                     <div class="field-content">
                  
                     <a class="zoom-ctrl gallery without-caption" href="https://cdn.shopify.com/s/files/1/0685/2647/3535/files/${image_name ?? thumbnail_url ?? thumbnail_src}" title="${display_title ?? title}">
                     <img src="https://cdn.shopify.com/s/files/1/0685/2647/3535/files/${image_name ?? thumbnail_url ?? thumbnail_src}" width="371" height="480" alt="  title  ">
                     </a>
                     </div>
                     </div>
                      <div class="title">
                      <label for="row-entry_index" style="text-transform:capitalize;" type="${type}"> ${display_title ?? title } </label>
                      </div>
                     </div>`;
              }
             
              jQuery('#grid-listing').html(htmlElement)
              jQuery('.grid-wrapper').css('display','block');
          }
        }
   })
}